import { PAGE_BUILDER_DOMAINS, HS_SITES_DOMAINS, HUBSPOT_COM, HUBSPOTQA_COM, HSAPPSTATIC_NET } from '../constants/domains';
import { fetchHcmsDataForCustomDomain } from '../data/hcmsApi';
export const getIsCustomDomain = hostname => {
  const parts = hostname.split('.');
  if (parts.length < 2) {
    return true; // Single part domains are considered custom
  }
  const baseDomain = parts.slice(parts.length - 2).join('.');
  return baseDomain !== HUBSPOTQA_COM && baseDomain !== HUBSPOT_COM && baseDomain !== HSAPPSTATIC_NET;
};
export const getInternalDomainConfig = hostname => {
  const parts = hostname.split('.');
  if (parts.length < 2) {
    return null;
  }

  // Direct O(1) lookup with last 2 parts for page builder and hs-sites domains
  const baseDomain = parts.slice(parts.length - 2).join('.');
  return PAGE_BUILDER_DOMAINS[baseDomain] || HS_SITES_DOMAINS[baseDomain] || null;
};
export const getHubletAndEnvOverrides = async hostname => {
  const internalDomainConfig = getInternalDomainConfig(hostname);
  const isCustomDomain = getIsCustomDomain(hostname);
  if (internalDomainConfig) {
    return internalDomainConfig;
  } else if (isCustomDomain) {
    const hcmsConfig = await fetchHcmsDataForCustomDomain();
    return hcmsConfig;
  }
  return {
    hublet: undefined,
    env: undefined
  };
};
export const redirectCurrentFrameToUrl = url => {
  window.location.href = url;
};

/**
 * Returns the current page URL on the hublet identified by a backend
 * WRONG_HUBLET response. The response's redirectUrl points to the API that
 * served the error, rather than to the public page.
 */
export const getHubletRedirectUrl = (currentUrl, redirectUrl) => {
  try {
    const pageUrl = new URL(currentUrl);
    const targetHubletUrl = new URL(redirectUrl);
    pageUrl.protocol = targetHubletUrl.protocol;
    pageUrl.host = targetHubletUrl.host;
    return pageUrl.toString();
  } catch (_unused) {
    return null;
  }
};